/** Execute GoBar selection: create task, filter command, or navigate to task. */
import { mergeNewTaskCreateData } from '@/features/tasks/context/tasksContextUtils';
import { parseTaskInput } from '@/features/tasks/utils/data/taskParser';

const resolveIds = (targets, displayMap) => {
  const keys = [...(displayMap?.keys() ?? [])];
  return targets.map((t) => keys.find((k) => k.toLowerCase() === t) ?? t);
};

export async function executeGoBarItem({
  item,
  searchTerm,
  command,
  addTask,
  setProjectFilter,
  setContextFilter,
  setHiddenProjects,
  setHiddenContexts,
  projectDisplayMap,
  contextDisplayMap,
  projectFilter,
  contextFilter,
  navigate,
  handleClose,
}) {
  if (item.isCreate) {
    const trimmed = searchTerm.trim();
    if (!trimmed) return;
    try {
      const parsedAttributes = parseTaskInput(trimmed);
      await addTask(
        mergeNewTaskCreateData(
          {},
          parsedAttributes,
          projectFilter,
          contextFilter,
        ),
      );
    } catch (error) {
      console.error('Error adding task from GoBar:', error);
      return;
    }
    handleClose();
    return;
  }

  if (item.isCommand) {
    setProjectFilter(
      command.projects.length > 0
        ? resolveIds(command.projects, projectDisplayMap)
        : [],
    );
    setContextFilter(
      command.contexts.length > 0
        ? resolveIds(command.contexts, contextDisplayMap)
        : [],
    );
    setHiddenProjects([]);
    setHiddenContexts([]);
    navigate('/app/organize');
  } else {
    navigate(`/app/today?task=${item.id}`);
  }
  handleClose();
}
